import { CircleAlertIcon } from "lucide-react"

const ConfirmModalContent: React.FC = () => (
  <div className="flex flex-col items-center">
    <div className="bg-gray-25 my-auto grid size-20 place-content-center rounded-full">
      <CircleAlertIcon size={32} />
    </div>
    <h1 className="my-2 text-xl font-bold text-gray-800">
      Exit Without Saving?
    </h1>
    <p className="my-2 text-gray-800">
      The current document will not be processed.
    </p>
  </div>
)

export default ConfirmModalContent
